import { Flex, Link } from "@chakra-ui/react";

import { ArrowBackIcon } from "@chakra-ui/icons";
import FormPF from "../../../../components/FormPF";
import { IProductItem } from "../../../../interfaces/Product";
import NextLink from "next/link";
import React from "react";
import Sac from "../../../../components/Contato/Sac";
import TitleDefault from "../../../../components/TitleDefault";
import fetchAPI from "../../../../lib/api";

interface Props {
  products: IProductItem[];
}

export default function ConsumidorFinal({ products }: Props) {
  return (
    <Flex
      w="full"
      flexDir="column"
      pt="60px"
      className="template-page page-slug-formulario"
    >
      <Flex
        w={["80%", "80%", "90%", "90%", "1170px"]}
        flexDir="column"
        mx="auto"
      >
        <NextLink href="/contato" passHref>
          <Link fontSize="14px" color="#00377B">
            <ArrowBackIcon mr={2} />
            Voltar para contato
          </Link>
        </NextLink>
        <Sac />
        <TitleDefault subtitulo="FORMULÁRIO" titulo="Preencha todos os dados" />
        <FormPF products={products} />
      </Flex>
    </Flex>
  );
}

export async function getStaticProps() {
  const products = await fetchAPI("/produtos?_limit=-1");
  return {
    props: { products },
    revalidate: 30,
  };
}
